import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconMapMarkerSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 10.401c0-3.044 2.298-5.4 5-5.4s5 2.356 5 5.4c0 1.47-.62 2.864-1.686 4.34-.902 1.25-2.057 2.472-3.31 3.797l-.004.005-.005-.005c-1.252-1.325-2.407-2.547-3.31-3.797C7.62 13.265 7 11.871 7 10.401Zm5-7.4c-3.926 0-7 3.375-7 7.4 0 2.065.88 3.87 2.064 5.51.987 1.368 2.251 2.704 3.502 4.027.236.25.471.498.704.747l.73.778.73-.778c.233-.249.468-.498.704-.747 1.25-1.323 2.515-2.659 3.502-4.026C18.12 14.272 19 12.466 19 10.4 19 6.375 15.926 3 12 3Zm.001 8.998a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconMapMarkerSharpLine);
export default Memo;
